import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { Sidebar, type IconType } from '@socrait/react';
import { useViewArchivedClassesFeature } from '~/featureFlags';

import { Period } from '~/services/types';

type LayoutWithSidebarProps = {
  isSimple?: boolean;
  periods?: Period[];
  activePeriodId?: string;
  onSelectPeriod?: (periodId: string) => void;
  onEditPress?: () => void;
  onArchivedClassesPress?: () => void;
  children: React.ReactNode;
};

export const LayoutWithSidebar = ({
  children,
  isSimple,
  periods,
  activePeriodId,
  onSelectPeriod,
  onEditPress,
  onArchivedClassesPress,
}: LayoutWithSidebarProps) => {
  const isArchivedClassesEnabled = useViewArchivedClassesFeature();

  const sidebarButtons = [
    {
      expandedText: `Edit Schedule and Classes`,
      iconType: 'edit' as IconType,
      onPress: onEditPress ?? (() => {}),
    },
  ];

  if (isArchivedClassesEnabled) {
    sidebarButtons.push({
      expandedText: `Archived Classes`,
      iconType: 'archive' as IconType,
      onPress: onArchivedClassesPress ?? (() => {}),
    });
  }

  return (
    <View style={styles.container}>
      <Sidebar
        isSimple={isSimple}
        periods={periods}
        activePeriodId={activePeriodId}
        onSelectPeriod={onSelectPeriod}
        containerStyle={styles.sidebar}
        sidebarButtons={sidebarButtons}
      />
      <ScrollView contentContainerStyle={styles.content}>{children}</ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    width: '100%',
  },
  content: {
    height: '100%',
  },
  sidebar: {
    zIndex: 1,
  },
});
